exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".font-bold-24[data-v-2b1abcbe]{font:normal normal 700 24px/32px Segoe UI;letter-spacing:0;color:#112639;opacity:1}.font-bold-16[data-v-2b1abcbe]{font:normal normal 700 16px/21px Segoe UI;letter-spacing:0;color:#112639;opacity:1}.font-semibold[data-v-2b1abcbe]{font:normal normal 600 16px/16px Segoe UI;letter-spacing:0;color:#112639;text-transform:uppercase;opacity:1}.font-regular[data-v-2b1abcbe]{font:normal normal normal 16px/16px Segoe UI;letter-spacing:0;color:#95a1ad;opacity:1}.icon[data-v-2b1abcbe]{font-size:1.5em;line-height:1.4em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-2b1abcbe","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/requeteurModifieur/FiltreSelection/FiltreSelection.scss
// module id = fO1L
// module chunks = 2